module.exports = __webpack_public_path__ + "img/d8e273f.svg";